import type { KoraConfig } from "@/types/clinic-configuration";

/**
 * Needs for i18next-scanner
 */
// t('Formal (usted)')
// t('Informal (vos)')
// t('Informal (tú)')
export const toneFormalityLabels: Record<KoraConfig.ToneFormality, string> = {
  "formal-usted": "Formal (usted)",
  "informal-vos": "Informal (vos)",
  "informal-tu": "Informal (tú)",
};

/**
 * A sample line in each register rather than a description of it — the
 * difference between usted, vos and tú is the pronoun itself, so showing
 * Kora actually saying it settles the choice faster than any explanation.
 *
 * Keys like every other string here, but the Spanish is the content: both
 * locales translate these to the same phrase, since a clinic picking how
 * Kora addresses patients in Spanish needs to read the Spanish whatever
 * language the console is in.
 */
/**
 * Needs for i18next-scanner
 */
// t('“¿En qué le puedo ayudar?”')
// t('“¿En qué te puedo ayudar, vos me decís?”')
// t('“¿En qué te puedo ayudar?”')
export const toneFormalityDescriptions: Record<
  KoraConfig.ToneFormality,
  string
> = {
  "formal-usted": "“¿En qué le puedo ayudar?”",
  "informal-vos": "“¿En qué te puedo ayudar, vos me decís?”",
  "informal-tu": "“¿En qué te puedo ayudar?”",
};

/**
 * Needs for i18next-scanner
 */
// t('Simplified')
// t('Traditional')
export const tonePunctuationLabels: Record<KoraConfig.TonePunctuation, string> =
  {
    simplified: "Simplified",
    traditional: "Traditional",
  };

/**
 * Ordinary translatable copy, unlike `toneFormalityDescriptions` — the
 * sentence explains the option and only the quoted sample inside it is
 * Spanish. That sample stays byte-identical in every locale: “Como estas?”
 * is missing its opening mark and its accents on purpose, since that
 * absence is the whole difference being described.
 */
/**
 * Needs for i18next-scanner
 */
// t('The way people write on WhatsApp: no opening marks (¿ ¡). “Como estas?”')
// t('Full Spanish punctuation, with opening marks. “¿Cómo estás?”')
export const tonePunctuationDescriptions: Record<
  KoraConfig.TonePunctuation,
  string
> = {
  simplified:
    "The way people write on WhatsApp: no opening marks (¿ ¡). “Como estas?”",
  traditional: "Full Spanish punctuation, with opening marks. “¿Cómo estás?”",
};

/**
 * Needs for i18next-scanner
 */
// t('None')
// t('Default')
// t('Custom')
export const preferredEmojisLabels: Record<KoraConfig.PreferredEmojis, string> =
  {
    none: "None",
    default: "Default",
    custom: "Custom",
  };
